<script>
export default {
  props: {
    perform: {
      type: Object,
      required: true
    }
  },
  setup() { },
  data() {
    return {
      hover: false
    }
  },
  computed: {
    hall() {
      return this.perform?.hall ?? { name: "Большая сцена", to: "main-hall", icon: "main-hall", icon_rounded: "main-hall-rounded" }
    }
  },
  methods: {
    hoverOver() {
      this.hover = true
    },
    hoverLeave() {
      this.hover = false
    }
  }
}
</script>

<template>
  <article
    class="bg-white rounded-lg flex relative flex-col xl:grid xl:grid-cols-12 gap-3 xl:gap-7 pb-7 xl:pb-0 xl:px-0"
  >
    <div class="col-start-1 col-end-13 xl:col-end-5">
      <router-link :to="`/theater/performs/${perform._id}`">
        <img
          loading="lazy"
          class="rounded-lg object-cover h-72 w-full"
          :src="`https://ucarecdn.com/${perform.img.fileKey}/-/format/auto/-/quality/smart/image.png`"
          :alt="perform.name"
        />
      </router-link>
    </div>
    <div class="col-start-1 xl:col-start-5 col-end-11 flex flex-col space-y-5 xl:py-7 px-4 xl:px-0">
      <div class="flex flex-row space-x-7">
        <router-link :to="`/theater/performs/${perform._id}`">
          <h2
            class="font-sans text-xl text-dark-gray leading-none my-auto hover:underline pt-0.5"
          >{{ perform.name }}</h2>
        </router-link>
        <r-button
          v-if="perform.isPremiere"
          size="sm"
          class="my-auto text-sm"
          cursor="default"
        >Премьера</r-button>
      </div>

      <p
        class="font-sans font-regular text-akcent text-lg"
        style="margin-top: 4px !important"
      >{{ perform.genre }}</p>

      <div>
        <p class="font-sans font-regular text-neutral text-lg">
          Автор:
          <b class="text-lg font-semibold">{{ perform.author }}</b>
        </p>
        <p class="font-sans font-regular text-neutral text-lg pt-1/2">
          Режиссер:
          <b class="text-lg font-semibold">{{ perform.producer }}</b>
        </p>
      </div>

      <div>
        <p class="font-sans font-regular text-neutral text-lg">{{ perform.snippet }}</p>
      </div>
    </div>

    <div class="col-start-11 col-end-13 hidden xl:flex pr-3 mt-16">
      <div class="flex flex-row space-x-1 ml-auto origin-top-right">
        <div class="h-12 w-12 -mt-2.5 bg-akcent flex rounded-md" style="transform: rotate(64deg)">
          <p
            class="m-auto origin-center text-white text-lg font-semibold"
            style="transform: rotate(-64deg)"
          >{{ perform.age_limit }}</p>
        </div>

        <router-link v-if="hall" :to="`/theater/halls/${hall.to}`">
          <div class="flex -mt-12 -ml-3.5">
            <r-icon
              :icon="hall.icon"
              @mouseover="hoverOver"
              @mouseleave="hoverLeave"
              class="w-22 h-22 cursor-pointer placeholder"
            ></r-icon>
          </div>
        </router-link>
        <div v-else class="flex -mt-12 -ml-3.5">
          <r-icon icon="main-hall" class="w-22 h-22 cursor-pointer placeholder"></r-icon>
        </div>
      </div>
    </div>
    <div
      v-show="hover"
      class="titleBlock z-50 text-lato text-sm font-normal transform text-center text-neutral bg-white rounded-md"
    >{{ hall.name }}</div>
  </article>
</template>

<style scoped>
.titleBlock {
  text-shadow: 0px 2px 4px #0000000a;
  padding: 5px 17px;
  box-shadow: 0px 2px 4px #0000000a;
  height: 25px;
  position: absolute;
  top: 37px;
  right: 77px;
}
</style>
